export const goldenDatasetStatusQueryKey = (encounterId: string) => ["golden-dataset-status", encounterId] as const;
